import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { Session } from './session.model';
import { SessionActions } from './session.actions';
import { CallState, LoadingState } from '@lyceo/shared/util-loading';

export const SESSION_FEATURE_KEY: string = 'session';

export interface SessionState extends EntityState<Session> {
  selectedSessionId: string | undefined;
  sessionCallState: CallState;
}

export const sessionAdapter: EntityAdapter<Session> =
  createEntityAdapter<Session>();

export const initialSessionState: SessionState = sessionAdapter.getInitialState(
  {
    selectedSessionId: undefined,
    sessionCallState: LoadingState.INIT,
  },
);

const reducer: ActionReducer<SessionState, Action> = createReducer(
  initialSessionState,
  on(
    SessionActions.loadSession,
    (state): SessionState => ({
      ...state,
      sessionCallState: LoadingState.LOADING,
    }),
  ),
  on(
    SessionActions.loadSessionSuccess,
    (state, action): SessionState =>
      sessionAdapter.upsertOne(action.session, {
        ...state,
        selectedSessionId: action.session.id,
        sessionCallState: LoadingState.LOADED,
      }),
  ),
  on(
    SessionActions.loadSessionFailure,
    (state, { error }): SessionState => ({
      ...state,
      sessionCallState: { errorMsg: error.message },
    }),
  ),
);

export function sessionReducer(
  state: SessionState | undefined,
  action: Action,
): SessionState {
  return reducer(state, action);
}
